import { ENTER, SPACE, TAB, ESCAPE } from '@angular/cdk/keycodes';
import { NgClass, NgStyle, NgTemplateOutlet, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Injectable, EventEmitter, TemplateRef, Component, ChangeDetectionStrategy, ViewChild, ContentChild, Output, InjectionToken, inject, Optional, Inject, Self, Input, NgModule } from '@angular/core';
import * as i2 from '@aposin/ng-aquila/icon';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { Subject } from 'rxjs';
import { takeUntil, filter, map } from 'rxjs/operators';
import * as i1 from '@angular/cdk/overlay';
import { Overlay, OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { TemplatePortal } from '@angular/cdk/portal';
import * as i2$1 from '@angular/platform-browser';
import * as i3 from '@angular/cdk/a11y';
import * as i4 from '@angular/cdk/platform';
import * as i5 from '@angular/cdk/bidi';
import * as i6 from '@aposin/ng-aquila/overlay';

/**
 * Popover content that will be rendered lazily
 * after the popover is opened for the first time.
 */
const _c0 = ["*"];
function NxPopoverComponent_ng_template_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngStyle", ctx_r1.arrowStyle);
  }
}
function NxPopoverComponent_ng_template_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵlistener("click", function NxPopoverComponent_ng_template_0_Conditional_3_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.emitCloseButtonClick());
    })("keyup", function NxPopoverComponent_ng_template_0_Conditional_3_Template_span_keyup_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._onCloseKeyup($event));
    })("keydown", function NxPopoverComponent_ng_template_0_Conditional_3_Template_span_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._onCloseKeydown($event));
    });
    i0.ɵɵelement(1, "nx-icon", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", ctx_r1._intl.closeIconLabel);
  }
}
function NxPopoverComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵlistener("click", function NxPopoverComponent_ng_template_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onClick($event));
    });
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵtemplate(2, NxPopoverComponent_ng_template_0_Conditional_2_Template, 1, 1, "div", 2)(3, NxPopoverComponent_ng_template_0_Conditional_3_Template, 2, 1, "span", 3);
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵprojection(5);
    i0.ɵɵelementContainer(6, 5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.classList);
    i0.ɵɵadvance();
    i0.ɵɵattribute("tabindex", ctx_r1.tabIndex);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.hidePopoverArrow ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showCloseButton ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", (tmp_6_0 = ctx_r1._lazyContent == null ? null : ctx_r1._lazyContent._template) !== null && tmp_6_0 !== undefined ? tmp_6_0 : null);
  }
}
class NxPopoverContentDirective {
  constructor(_template) {
    this._template = _template;
  }
  static {
    this.ɵfac = function NxPopoverContentDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPopoverContentDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxPopoverContentDirective,
      selectors: [["ng-template", "nxPopoverContent", ""]]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPopoverContentDirective, [{
    type: Directive,
    args: [{
      selector: 'ng-template[nxPopoverContent]',
      standalone: true
    }]
  }], () => [{
    type: i0.TemplateRef
  }], null);
})();

/** Popover data that requires internationalization. */
class NxPopoverIntl {
  constructor() {
    /**
     * Stream that emits whenever the labels here are changed. Use this to notify
     * components if the labels have changed after initialization.
     */
    this.changes = new Subject();
    /** Aria-label for the delete icon. */
    this.closeIconLabel = 'close';
  }
  static {
    this.ɵfac = function NxPopoverIntl_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPopoverIntl)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NxPopoverIntl,
      factory: NxPopoverIntl.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPopoverIntl, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class NxPopoverComponent {
  // necessary for direct usages of popover where the popover should not be traversable through tabs like in the natural language form
  /** Sets the tabIndex for the popover. Will only be considered if triggerType is 'manual' */
  set tabIndex(value) {
    this._tabIndex = value;
  }
  /**
   * gets the tabindex for the popover
   * if triggerType='hover' -> null
   * if triggerType='click' -> 0
   * if triggerType='manual' -> whatever is set on tabIndex. Defaults to 0 on 'manual'
   */
  get tabIndex() {
    if (this.triggerType === 'manual') {
      return this._tabIndex;
    }
    return this.triggerType === 'hover' ? null : 0;
  }
  constructor(_intl, _cdr) {
    this._intl = _intl;
    this._cdr = _cdr;
    /** Event emitted when the popover is closed. */
    this.closed = new EventEmitter();
    /** @docs-private */
    this.closeButtonClick = new Subject();
    /** @docs-private */
    this.hidePopoverArrow = false;
    /** @docs-private */
    this.showCloseButton = false;
    /** @docs-private */
    this.triggerType = 'click';
    this._tabIndex = 0;
    /** @docs-private */
    this.arrowStyle = {};
    this._destroyed = new Subject();
  }
  ngOnInit() {
    this._intl.changes.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this._cdr.markForCheck();
    });
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this.closed.complete();
  }
  /**
   * Emits event to notify the popover trigger directive that the close button was clicked.
   * @docs-private
   */
  emitCloseButtonClick() {
    this.closeButtonClick.next();
  }
  /** @docs-private */
  _onCloseKeyup($event) {
    if ($event && ($event.keyCode === ENTER || $event.keyCode === SPACE)) {
      this.emitCloseButtonClick();
    }
    $event.preventDefault();
  }
  /** @docs-private */
  _onCloseKeydown($event) {
    if ($event.keyCode === SPACE) {
      $event.preventDefault();
    }
  }
  /** @docs-private */
  emitClosedEvent() {
    this.closed.emit();
  }
  /** @docs-private */
  get classList() {
    if (this.direction) {
      // Returning an array here caused an error that the classes were not set
      // after a prod build. Couldn't reproduce it properly in an isolated way.
      // As it doesn't make sense to return an array for a single value anyway
      // changed it to a string and that seems to work.
      return `nx-popover--${this.direction}`;
    }
    return '';
  }
  /** Prevent the popover from closing when the user clicks on the popover content. */
  _onClick(event) {
    event.stopPropagation();
  }
  static {
    this.ɵfac = function NxPopoverComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPopoverComponent)(i0.ɵɵdirectiveInject(NxPopoverIntl), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NxPopoverComponent,
      selectors: [["nx-popover"]],
      contentQueries: function NxPopoverComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NxPopoverContentDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._lazyContent = _t.first);
        }
      },
      viewQuery: function NxPopoverComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
        }
      },
      outputs: {
        closed: "closed"
      },
      exportAs: ["nxPopover"],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      consts: [["role", "dialog", "aria-hidden", "false", 1, "nx-popover", 3, "click", "ngClass"], [1, "nx-popover__content"], [1, "nx-popover__arrow", 3, "ngStyle"], ["tabindex", "0", "role", "button", 1, "nx-popover__close-icon"], [3, "id"], [3, "ngTemplateOutlet"], ["tabindex", "0", "role", "button", 1, "nx-popover__close-icon", 3, "click", "keyup", "keydown"], ["aria-hidden", "true", "name", "close"]],
      template: function NxPopoverComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, NxPopoverComponent_ng_template_0_Template, 7, 6, "ng-template");
        }
      },
      dependencies: [NgClass, NgStyle, NxIconModule, i2.NxIconComponent, NgTemplateOutlet],
      styles: [".nx-popover[_ngcontent-%COMP%]{position:relative}.nx-popover__content[_ngcontent-%COMP%]{font-size:var(--popover-content-font-size);line-height:var(--popover-content-line-height);font-weight:var(--popover-content-font-weight);letter-spacing:var(--popover-content-letter-spacing);background-color:var(--popover-background-color);color:var(--popover-text-color);border:1px solid var(--popover-border-color);border-radius:4px;box-shadow:var(--shadow-small);padding:24px 32px;display:block}.nx-popover__content[_ngcontent-%COMP%]:has(.nx-popover__close-icon){padding:24px 48px 24px 32px}.nx-popover__content[_ngcontent-%COMP%]:focus{outline:none}.nx-popover__content[_ngcontent-%COMP%]::-moz-focus-inner{border:0}.nx-popover__close-icon[_ngcontent-%COMP%]{display:flex;position:absolute;top:16px;right:16px;cursor:pointer;font-size:var(--popover-close-icon-size);color:var(--popover-close-icon-color);border-radius:2px}[dir=rtl][_ngcontent-%COMP%]   .nx-popover__close-icon[_ngcontent-%COMP%]{right:auto;left:4px}.nx-popover__close-icon[_ngcontent-%COMP%]:focus{outline:none}.nx-popover__close-icon[_ngcontent-%COMP%]::-moz-focus-inner{border:0}@media screen and (forced-colors: active){.nx-popover__close-icon[_ngcontent-%COMP%]{color:buttonText}}.nx-popover__close-icon.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-popover__close-icon.cdk-keyboard-focused[_ngcontent-%COMP%]{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}.nx-popover__arrow[_ngcontent-%COMP%]{width:12px;height:12px;background-color:inherit;position:absolute;transform:translate(-50%);border-top:1px solid var(--popover-border-color);border-left:1px solid var(--popover-border-color)}.nx-popover--top[_ngcontent-%COMP%]   .nx-popover__arrow[_ngcontent-%COMP%]{transform:translate(-50%) rotate(225deg);bottom:-5px;box-shadow:2px 2px 1px 1px var(--popover-background-color),-2px -2px -4px var(--shadow-small-color)}.nx-popover--right[_ngcontent-%COMP%]   .nx-popover__arrow[_ngcontent-%COMP%]{transform:translateY(-50%) rotate(-45deg);left:-5px}.nx-popover--bottom[_ngcontent-%COMP%]   .nx-popover__arrow[_ngcontent-%COMP%]{transform:translate(-50%) rotate(45deg);top:-5px}.nx-popover--left[_ngcontent-%COMP%]   .nx-popover__arrow[_ngcontent-%COMP%]{transform:translateY(-50%) rotate(135deg);right:-5px}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPopoverComponent, [{
    type: Component,
    args: [{
      selector: 'nx-popover',
      changeDetection: ChangeDetectionStrategy.OnPush,
      exportAs: 'nxPopover',
      imports: [NgClass, NgStyle, NxIconModule, NgTemplateOutlet],
      template: "<ng-template>\n    <div [ngClass]=\"classList\" class=\"nx-popover\" role=\"dialog\" aria-hidden=\"false\" (click)=\"_onClick($event)\">\n        <div class=\"nx-popover__content\" [attr.tabindex]=\"tabIndex\">\n            @if (!hidePopoverArrow) {\n                <div class=\"nx-popover__arrow\" [ngStyle]=\"arrowStyle\"></div>\n            }\n            @if (showCloseButton) {\n                <span\n                    [attr.aria-label]=\"_intl.closeIconLabel\"\n                    tabindex=\"0\"\n                    role=\"button\"\n                    class=\"nx-popover__close-icon\"\n                    (click)=\"emitCloseButtonClick()\"\n                    (keyup)=\"_onCloseKeyup($event)\"\n                    (keydown)=\"_onCloseKeydown($event)\"\n                >\n                    <nx-icon aria-hidden=\"true\" name=\"close\"></nx-icon>\n                </span>\n            }\n\n            <span [id]=\"id\">\n                <ng-content></ng-content>\n                <ng-container [ngTemplateOutlet]=\"_lazyContent?._template ?? null\"></ng-container>\n            </span>\n        </div>\n    </div>\n</ng-template>\n",
      styles: [".nx-popover{position:relative}.nx-popover__content{font-size:var(--popover-content-font-size);line-height:var(--popover-content-line-height);font-weight:var(--popover-content-font-weight);letter-spacing:var(--popover-content-letter-spacing);background-color:var(--popover-background-color);color:var(--popover-text-color);border:1px solid var(--popover-border-color);border-radius:4px;box-shadow:var(--shadow-small);padding:24px 32px;display:block}.nx-popover__content:has(.nx-popover__close-icon){padding:24px 48px 24px 32px}.nx-popover__content:focus{outline:none}.nx-popover__content::-moz-focus-inner{border:0}.nx-popover__close-icon{display:flex;position:absolute;top:16px;right:16px;cursor:pointer;font-size:var(--popover-close-icon-size);color:var(--popover-close-icon-color);border-radius:2px}[dir=rtl] .nx-popover__close-icon{right:auto;left:4px}.nx-popover__close-icon:focus{outline:none}.nx-popover__close-icon::-moz-focus-inner{border:0}@media screen and (forced-colors: active){.nx-popover__close-icon{color:buttonText}}.nx-popover__close-icon.cdk-keyboard-focused{box-shadow:var(--focus-box-shadow)}@media screen and (forced-colors: active),(forced-colors: active){.nx-popover__close-icon.cdk-keyboard-focused{box-shadow:0 0 0 2px background,0 0 0 6px CanvasText;outline:4px solid CanvasText;outline-offset:2px}}.nx-popover__arrow{width:12px;height:12px;background-color:inherit;position:absolute;transform:translate(-50%);border-top:1px solid var(--popover-border-color);border-left:1px solid var(--popover-border-color)}.nx-popover--top .nx-popover__arrow{transform:translate(-50%) rotate(225deg);bottom:-5px;box-shadow:2px 2px 1px 1px var(--popover-background-color),-2px -2px -4px var(--shadow-small-color)}.nx-popover--right .nx-popover__arrow{transform:translateY(-50%) rotate(-45deg);left:-5px}.nx-popover--bottom .nx-popover__arrow{transform:translate(-50%) rotate(45deg);top:-5px}.nx-popover--left .nx-popover__arrow{transform:translateY(-50%) rotate(135deg);right:-5px}\n"]
    }]
  }], () => [{
    type: NxPopoverIntl
  }, {
    type: i0.ChangeDetectorRef
  }], {
    templateRef: [{
      type: ViewChild,
      args: [TemplateRef]
    }],
    _lazyContent: [{
      type: ContentChild,
      args: [NxPopoverContentDirective]
    }],
    closed: [{
      type: Output
    }]
  });
})();
let nextId = 0;
const BASE_OFFSET = 16;
/** Injection token that determines the scroll handling while a popover is open. */
const NX_POPOVER_SCROLL_STRATEGY = new InjectionToken('nx-popover-scroll-strategy', {
  providedIn: 'root',
  factory: () => {
    const overlay = inject(Overlay);
    return () => overlay.scrollStrategies.close();
  }
});
/**
 * @docs-private
 * @deprecated No longer used.
 * @deletion-target 18.0.0
 */
function NX_POPOVER_SCROLL_STRATEGY_PROVIDER_FACTORY(overlay) {
  return () => overlay.scrollStrategies.close();
}
/**
 * @docs-private
 * @deprecated No longer used.
 * @deletion-target 18.0.0
 */
const NX_POPOVER_SCROLL_STRATEGY_PROVIDER = {
  provide: NX_POPOVER_SCROLL_STRATEGY,
  useFactory: NX_POPOVER_SCROLL_STRATEGY_PROVIDER_FACTORY,
  deps: [Overlay]
};
/** Injection token to be used to override the default options for `nxPopover`. */
const POPOVER_DEFAULT_OPTIONS = new InjectionToken('popover-default-options', {
  providedIn: 'root',
  factory: POPOVER_DEFAULT_OPTIONS_FACTORY
});
function POPOVER_DEFAULT_OPTIONS_FACTORY() {
  return {
    popoverWidth: undefined,
    popoverMaxWidth: undefined
  };
}
/**
 * Creates an error to be thrown if the user provided an invalid popover direction.
 * @docs-private
 */
function getNxPopoverInvalidDirectionError(direction) {
  return Error(`Popover direction "${direction}" is invalid.`);
}
class NxPopoverTriggerDirective {
  /** Whether to show or hide the popover. */
  set show(value) {
    value = coerceBooleanProperty(value);
    if (this._show !== value) {
      this._show = value;
      if (this._show) {
        if (this.popover.templateRef) {
          this.openPopover();
        } else {
          setTimeout(() => {
            this.openPopover();
          });
        }
      } else {
        this.closePopover();
      }
    }
  }
  get show() {
    return this._show;
  }
  /** Whether to show a close button. By default a close icon is only shown for trigger type click. Can't be used for trigger type hover. */
  set closeable(value) {
    this._closeable = coerceBooleanProperty(value);
    if (this.popover) {
      this.popover.showCloseButton = this.isCloseable();
    }
  }
  get closeable() {
    return this._closeable;
  }
  /** Whether the popover should be closed on click outside of the popover in the trigger modes 'manual' and 'click'. */
  set closeOnClickOutside(value) {
    this._closeOnClickOutside = coerceBooleanProperty(value);
  }
  get closeOnClickOutside() {
    return this._closeOnClickOutside;
  }
  /** Whether to show the popover arrow. By default set to true */
  set hidePopoverArrow(value) {
    this._hidearrow = coerceBooleanProperty(value);
    if (this.popover) {
      this.popover.hidePopoverArrow = this._hidearrow;
    }
  }
  get hidePopoverArrow() {
    return this._hidearrow;
  }
  /** Popover width */
  set popoverWidth(value) {
    this._popoverWidth = value;
  }
  get popoverWidth() {
    return this._popoverWidth || this._defaultOptions?.popoverWidth;
  }
  /** Popover max-width */
  set popoverMaxWidthh(value) {
    this._popoverMaxWidth = value;
  }
  get popoverMaxWidth() {
    return this._popoverMaxWidth || this._defaultOptions?.popoverMaxWidth;
  }
  /** Whether the popover opens in modal state. */
  set modal(value) {
    this._modal = coerceBooleanProperty(value);
  }
  get modal() {
    return this._modal;
  }
  /** Sets the scroll strategy. 'close' closes the popover on scroll while 'reposition' scrolls the popover with the origin. */
  set scrollStrategy(value) {
    if (this.#scrollStrategy !== value) {
      this.#scrollStrategy = value;
      this._scrollStrategyFactory = value ? this.getScrollStrategyFactory(value) : this._defaultScrollStrategyFactory;
      this._cdr.markForCheck();
    }
  }
  get scrollStrategy() {
    return this.#scrollStrategy;
  }
  #scrollStrategy;
  constructor(overlay, elementRef, viewContainerRef, eventManager, _focusTrapFactory, _focusMonitor, _ngZone, _platform, _dir, _defaultOptions, _defaultScrollStrategyFactory, _cdr, _triggerButton) {
    this.overlay = overlay;
    this.elementRef = elementRef;
    this.viewContainerRef = viewContainerRef;
    this.eventManager = eventManager;
    this._focusTrapFactory = _focusTrapFactory;
    this._focusMonitor = _focusMonitor;
    this._ngZone = _ngZone;
    this._platform = _platform;
    this._dir = _dir;
    this._defaultOptions = _defaultOptions;
    this._defaultScrollStrategyFactory = _defaultScrollStrategyFactory;
    this._cdr = _cdr;
    this._triggerButton = _triggerButton;
    this._overlayDestroyed = new Subject();
    /** Element that was focused before the Popover was opened. Save this to restore upon close. */
    this._elementFocusedBeforePopoverWasOpened = null;
    this._manualListeners = new Map();
    this._possiblePopoverDirections = ['bottom', 'top', 'left', 'right'];
    // Do not initialize IntersectionObserver unless available for SSR compatibility
    this.closeOnLeftViewport = typeof globalThis.IntersectionObserver !== 'undefined' ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this._ngZone.run(() => this.overlayRef?.detach());
        }
        this.closeOnLeftViewport.disconnect();
      });
    }, {
      threshold: 0.2
    }) : undefined;
    /** @docs-private */
    this.id = 'nx-popover-' + nextId++;
    /** An event is emitted if the visibility status of the popover changes. */
    this.changeShow = new EventEmitter();
    this._show = false;
    this._closeable = null;
    this._closeOnClickOutside = true;
    this._hidearrow = null;
    /** Sets the desired direction to open the popover. E.g., right, left, bottom, top */
    this.direction = 'right';
    /** Whether the popover will be opened automatically. */
    this.popoverInitialVisible = false;
    /** An event is emitted when the visibility of the popopver changes. */
    this.visibleChange = new EventEmitter(); // TODO this should be an output
    this._modal = false;
    // If nxPopoverTrigger equals to 'hover' the popover opens on mouseenter and closes on mouseout.
    // If nxPopoverTrigger equals to 'click' the popover opens on click and closes on a click of the close icon or pressing ESC key.
    // If nxPopoverTrigger equals to 'manual' the popover opens only when programatically requested.
    /** Sets the way to trigger the popover. Options are hover, click, manual */
    this.trigger = 'click';
    this._destroyed = new Subject();
    /** Strategy factory that will be used to handle scrolling while the popover panel is open. */
    this._scrollStrategyFactory = this._defaultScrollStrategyFactory;
    if (!this._platform.IOS && !this._platform.ANDROID) {
      this._manualListeners.set('mouseenter', () => {
        if (this.trigger === 'hover') {
          this.show = true;
        }
      }).set('mouseleave', () => {
        if (this.trigger === 'hover') {
          this.show = false;
        }
      }).set('keydown', event => {
        switch (event.keyCode) {
          case SPACE:
            if (event?.target?.tagName !== 'BUTTON') {
              event?.preventDefault();
            }
            this.handleClick();
            break;
          case ENTER:
            event?.preventDefault();
            this.handleClick();
            break;
          case TAB:
            if (this.trigger === 'hover') {
              this.show = !this.isOpen;
            }
            break;
          default:
        }
      });
    } else {
      this._manualListeners.set('touchstart', () => {
        if (this.trigger === 'hover') {
          this.show = true;
        }
      });
    }
    this._manualListeners.forEach((listener, event) => this.elementRef.nativeElement.addEventListener(event, listener));
    this._dir?.change.pipe(takeUntil(this._destroyed)).subscribe(this._dirChangeHandler.bind(this));
  }
  ngAfterViewInit() {
    this._focusMonitor.monitor(this.elementRef.nativeElement, true).pipe(takeUntil(this._destroyed)).subscribe(origin => {
      if (origin === 'keyboard' && this.trigger === 'hover') {
        this._ngZone.run(() => this.show = true);
      }
    });
    this.popover.id = this.id;
    this.popover.closeButtonClick.pipe(takeUntil(this._destroyed)).subscribe(() => {
      this.show = false;
    });
    if (this.popoverInitialVisible || this._show) {
      this.show = true;
    }
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
    this.show = false;
    this._focusMonitor.stopMonitoring(this.elementRef.nativeElement);
    // Clean up the event listeners set in the constructor
    this._manualListeners.forEach((listener, event) => {
      this.elementRef.nativeElement.removeEventListener(event, listener);
    });
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
    this._manualListeners.clear();
    this._overlayDestroyed.next();
    this._overlayDestroyed.complete();
  }
  /** @docs-private */
  get isOpen() {
    return this.overlayRef && this.createOverlay().hasAttached();
  }
  /** @docs-private */
  isCloseable() {
    return this.trigger === 'click' && this._closeable === null || !!this._closeable && this.trigger !== 'hover';
  }
  /** Update the popover with the given position strategy. */
  updatePosition() {
    if (this._positionStrategy) {
      this._positionStrategy.apply();
    }
  }
  /** @docs-private */
  handleClick() {
    if (this.trigger === 'click') {
      this.show = !this.isOpen;
    } else if (this.trigger === 'hover') {
      this.show = true;
    }
  }
  /** Open the popover instance. */
  open() {
    this.show = true;
  }
  /** Close the popover instance. */
  close() {
    this.show = false;
  }
  /** Toggle the popover instance. */
  toggle() {
    this.show = !this.show;
  }
  openPopover() {
    if (!this.createOverlay().hasAttached()) {
      this.setPopoverProperties();
      this._embeddedViewRef = this.createOverlay().attach(this.portal);
      if (this.trigger !== 'hover') {
        if (this._triggerButton) {
          const triggerButton = this._triggerButton;
          triggerButton.setTriggerActive();
          this._embeddedViewRef.onDestroy(() => triggerButton.setTriggerInactive());
        }
        const element = this.getPopoverContainer();
        this._focusTrap = this._focusTrapFactory.create(element);
        this._elementFocusedBeforePopoverWasOpened = this.elementRef.nativeElement;
        this._focusMonitor.monitor(element.querySelector('.nx-popover__content'));
        const closeIcon = element.querySelector('.nx-popover__close-icon');
        if (closeIcon) {
          this._focusMonitor.monitor(closeIcon);
        }
        setTimeout(() => {
          // prevent page scroll, when it lose focus from trigger element.
          this._autoFocusFirstTabbableElement(element);
        });
        // attach a close click listener only if it makes sense (ignore it on hover e.g.)
        if (this.closeOnClickOutside) {
          this.waitForClose();
        }
      }
    }
  }
  /** Sets some popover component properties that are needed to render it properly. */
  setPopoverProperties() {
    this.popover.triggerType = this.trigger;
    this.popover.showCloseButton = this.isCloseable();
  }
  /**
   * Autofocus the first tabbable element inside of the popover, if there is not a tabbable element,
   * focus the popover instead.
   */
  _autoFocusFirstTabbableElement(element) {
    this._focusTrap.focusInitialElementWhenReady().then(hasMovedFocus => {
      // If we didn't find any focusable elements inside the popover, focus the
      // container so the user can't tab into other elements behind it.
      if (!hasMovedFocus) {
        element.focus();
      }
    });
  }
  // detaches the overlay
  // we are listening to the detachments observable which will then emit the nxClosed event
  // on the popover component
  closePopover() {
    if (this.overlayRef.hasAttached()) {
      if (this.trigger !== 'hover') {
        const element = this.getPopoverContainer();
        this._focusMonitor.stopMonitoring(element.querySelector('.nx-popover__content'));
        this._focusMonitor.stopMonitoring(element.querySelector('.nx-popover__close-icon'));
        setTimeout(() => {
          this._returnFocusAfterPopover();
        });
      }
      this.overlayRef.detach();
      this._embeddedViewRef = null;
      if (this._focusTrap) {
        this._focusTrap.destroy();
      }
    }
  }
  getScrollStrategyFactory(scrollStrategy) {
    switch (scrollStrategy) {
      case 'reposition':
        return this.overlay.scrollStrategies.reposition;
      default:
        return this.overlay.scrollStrategies.close;
    }
  }
  createOverlay() {
    if (!this.overlayRef) {
      this.portal = new TemplatePortal(this.popover.templateRef, this.viewContainerRef);
      const overlayState = new OverlayConfig();
      overlayState.width = this.popoverWidth;
      overlayState.maxWidth = this.popoverMaxWidth;
      overlayState.positionStrategy = this.getPosition();
      this._positionStrategy = overlayState.positionStrategy;
      overlayState.scrollStrategy = this._scrollStrategyFactory();
      overlayState.scrollStrategy.enable();
      overlayState.direction = this._dir?.value || 'ltr';
      if (this._modal) {
        overlayState.hasBackdrop = true;
      }
      this.overlayRef = this.overlay.create(overlayState);
      this.subscribeToPositions(overlayState.positionStrategy);
      this._subscribeToAttach();
      this._subscribeToDetach();
      this._subscribeToKeypress();
      if (this._modal && this._closeOnClickOutside) {
        this._subscribeToBackdropClick();
      }
    }
    return this.overlayRef;
  }
  subscribeToPositions(position) {
    position.positionChanges.pipe(takeUntil(this._overlayDestroyed)).subscribe(change => {
      const pair = change.connectionPair;
      this.positionOverlay(pair);
      this.positionArrow(pair);
      this.closeOnLeftViewport?.observe(this.elementRef.nativeElement);
      // These position changes arrive too late,
      // We have to trigger the change detection manually
      // as it's detached from any render hierarchy
      // and only updated by the overlay when attached.
      if (this._embeddedViewRef && !this._embeddedViewRef.destroyed) {
        this._embeddedViewRef.detectChanges();
      }
    });
  }
  // for modal popovers close the popover on backdrop clicks
  _subscribeToBackdropClick() {
    this.overlayRef.backdropClick().pipe(takeUntil(this._overlayDestroyed)).subscribe(event => {
      this.show = false;
    });
  }
  // Emit the nxClosed and the show status change event on the popover component when the overlay detaches
  _subscribeToDetach() {
    this.overlayRef.detachments().pipe(takeUntil(this._overlayDestroyed)).subscribe(data => {
      // This is an exception: when the popover is closed by a scrolling event,
      // then only the detached method is called but the show state variable remains unchanged.
      if (this.show) {
        this.show = false;
      }
      this.changeShow.emit(this._show);
      this.popover.emitClosedEvent();
    });
  }
  _subscribeToAttach() {
    this.overlayRef.attachments().pipe(takeUntil(this._overlayDestroyed)).subscribe(data => {
      this.changeShow.emit(this._show);
    });
  }
  _subscribeToKeypress() {
    this.overlayRef.keydownEvents().pipe(filter(event => event.keyCode === ESCAPE), takeUntil(this._overlayDestroyed)).subscribe(event => {
      if (this.isOpen) {
        this.show = false;
      }
    });
  }
  // subscribe to document clicks when trigger='click' to close the popover on clicks on the background
  waitForClose() {
    return this.overlayRef.outsidePointerEvents().pipe(map(event => event.target), filter(target => !this.elementRef.nativeElement.contains(target)), takeUntil(this.popover.closed)).subscribe(() => {
      this.show = false;
    });
  }
  positionOverlay(pair) {
    if (pair.originX === 'end' && pair.overlayX === 'start') {
      this.popover.direction = this.isRtl ? 'left' : 'right';
    } else if (pair.originY === 'bottom' && pair.overlayY === 'top') {
      this.popover.direction = 'bottom';
    } else if (pair.originX === 'start' && pair.overlayX === 'end') {
      this.popover.direction = this.isRtl ? 'right' : 'left';
    } else if (pair.originY === 'top' && pair.overlayY === 'bottom') {
      this.popover.direction = 'top';
    }
  }
  positionArrow(pair) {
    const parentElementPositionX = this.elementRef.nativeElement.getBoundingClientRect().left;
    const parentElementWidth = this.elementRef.nativeElement.getBoundingClientRect().width / 2;
    const parentElementLeftOffset = this.overlayRef.overlayElement.parentElement.offsetLeft;
    const overlayElementLeftOffset = this.overlayRef.overlayElement.offsetLeft;
    // calculation for x position of the parent element. In this case, overlay left offset is the one thing to consider.
    const targetPosition = parentElementPositionX + parentElementWidth - (parentElementLeftOffset + overlayElementLeftOffset);
    if (pair.originX === pair.overlayX) {
      const direction = 'left';
      const arrowStyle = {
        left: '0'
      };
      arrowStyle[direction] = targetPosition + 'px';
      this.popover.arrowStyle = arrowStyle;
    }
    if ((pair.originY === 'bottom' || pair.originY === 'top') && pair.overlayX === 'center') {
      this.popover.arrowStyle = {
        left: targetPosition + 'px'
      };
    }
    if ((pair.originX === 'end' || pair.originX === 'start') && pair.overlayY === 'center') {
      this.popover.arrowStyle = {
        top: '50%'
      };
    }
  }
  getPosition() {
    const origin = this._getOrigin(this.direction);
    const overlay = this._getOverlayPosition(this.direction);
    const offset = this._getOffset(this.direction);
    const fallbacks = this._getFallbackPositions(this.direction);
    return this.overlay.position().flexibleConnectedTo(this.elementRef).withPositions([{
      ...origin,
      ...overlay,
      ...offset
    }, ...fallbacks]).withFlexibleDimensions(false);
  }
  /** Returns the focus to the element focused before the Popover was open. */
  _returnFocusAfterPopover() {
    const toFocus = this._elementFocusedBeforePopoverWasOpened;
    // We need the extra check, because IE can set the `activeElement` to null in some cases.
    if (toFocus && typeof toFocus.focus === 'function') {
      toFocus.focus();
    }
  }
  /** Returns the main popover container of the injected content. */
  getPopoverContainer() {
    return this.overlayRef.overlayElement.querySelector('.nx-popover');
  }
  /**
   * Returns the origin position based on the user's direction preference.
   */
  _getOrigin(direction) {
    switch (direction) {
      case 'top':
      case 'bottom':
        {
          return {
            originX: 'center',
            originY: direction
          };
        }
      case 'left':
        {
          return {
            originX: this.isRtl ? 'end' : 'start',
            originY: 'center'
          };
        }
      case 'right':
        {
          return {
            originX: this.isRtl ? 'start' : 'end',
            originY: 'center'
          };
        }
      default:
        {
          throw getNxPopoverInvalidDirectionError(direction);
        }
    }
  }
  /** Returns the overlay position based on the user's direction preference */
  _getOverlayPosition(direction) {
    switch (direction) {
      case 'top':
      case 'bottom':
        {
          return {
            overlayX: 'center',
            overlayY: this._getInversePosition(direction)
          };
        }
      case 'left':
        {
          return {
            overlayX: this.isRtl ? 'start' : 'end',
            overlayY: 'center'
          };
        }
      case 'right':
        {
          return {
            overlayX: this.isRtl ? 'end' : 'start',
            overlayY: 'center'
          };
        }
      default:
        {
          throw getNxPopoverInvalidDirectionError(direction);
        }
    }
  }
  /** Returns the overlay offset required by the user's direction preference */
  _getOffset(direction) {
    switch (direction) {
      case 'top':
        {
          return {
            offsetY: BASE_OFFSET * -1
          };
        }
      case 'bottom':
        {
          return {
            offsetY: BASE_OFFSET
          };
        }
      case 'left':
        {
          return {
            offsetX: BASE_OFFSET * -1
          };
        }
      case 'right':
        {
          return {
            offsetX: BASE_OFFSET
          };
        }
      default:
        {
          throw getNxPopoverInvalidDirectionError(direction);
        }
    }
  }
  /** Returns the opposite direction, using aquila popover direction naming: top, right, bottom, left */
  _getInversePopoverDirection(direction) {
    const popoverDirectionPairs = {
      top: 'bottom',
      right: 'left',
      bottom: 'top',
      left: 'right'
    };
    return popoverDirectionPairs[direction];
  }
  /** Returns the opposite position, using angular position naming: top, bottom, start, end, center */
  _getInversePosition(position) {
    const positionPairs = {
      top: 'bottom',
      bottom: 'top',
      start: 'end',
      end: 'start',
      center: 'center'
    };
    return positionPairs[position];
  }
  /**
   * Returns an array of fallback positions for popover, following the algoritm:
   * 1) Slightly alternate preferred position if applicable. I.e. for 'top' try 'top-start' and 'top-end' positioning.
   * 2) Try the opposite position, i.e. for 'top' try 'bottom'.
   * 3) Slightly alternate opposite position, i.e. 'bottom-start', 'bottom-end'.
   * 4) All remaining positions from positions list.
   */
  _getFallbackPositions(direction, possibleDirections = this._possiblePopoverDirections) {
    if (!direction) {
      return [];
    }
    const remainigDirections = possibleDirections.filter(possibleDirection => possibleDirection !== direction);
    let fallbackPositions = [];
    switch (direction) {
      case 'top':
      case 'bottom':
        {
          fallbackPositions = this._getVerticalFallbackPositionPairs(direction);
          break;
        }
      case 'left':
      case 'right':
        {
          fallbackPositions = this._getHorizontalFallbackPositionPairs(direction);
          break;
        }
    }
    const inverseDirection = this._getInversePopoverDirection(direction);
    const nextFallbackPosition = remainigDirections.includes(inverseDirection) ? inverseDirection : possibleDirections[0];
    return [...fallbackPositions, ...this._getFallbackPositions(nextFallbackPosition, remainigDirections)];
  }
  /** Calculates fallbacks for vertical popover positioning */
  _getVerticalFallbackPositionPairs(direction) {
    const isSelectedDirection = direction === this.direction;
    const verticalFallbackPositionPairs = [];
    const basePositionPair = {
      ...this._getOrigin(direction),
      ...this._getOverlayPosition(direction),
      ...this._getOffset(direction)
    };
    if (!isSelectedDirection) {
      // HINT: selected direction matches basePosition, so we don't need to repeat it in fallback
      verticalFallbackPositionPairs.push(basePositionPair);
    }
    verticalFallbackPositionPairs.push({
      ...basePositionPair,
      originX: 'start',
      overlayX: 'start'
    }, {
      ...basePositionPair,
      originX: 'end',
      overlayX: 'end'
    });
    return verticalFallbackPositionPairs;
  }
  /** Calculates fallbacks for horizontal popover positioning */
  _getHorizontalFallbackPositionPairs(direction) {
    const offset = this._getOffset(direction);
    return [{
      ...this._getOrigin(direction),
      ...this._getOverlayPosition(direction),
      ...offset
    }];
  }
  _dirChangeHandler() {
    if (this.overlayRef) {
      this.closePopover();
      this.overlayRef.dispose();
      this.overlayRef = null;
      this._overlayDestroyed.next();
    }
  }
  get isRtl() {
    return this._dir?.value === 'rtl';
  }
  static {
    this.ɵfac = function NxPopoverTriggerDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPopoverTriggerDirective)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i2$1.EventManager), i0.ɵɵdirectiveInject(i3.ConfigurableFocusTrapFactory), i0.ɵɵdirectiveInject(i3.FocusMonitor), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i4.Platform), i0.ɵɵdirectiveInject(i5.Directionality, 8), i0.ɵɵdirectiveInject(POPOVER_DEFAULT_OPTIONS, 8), i0.ɵɵdirectiveInject(NX_POPOVER_SCROLL_STRATEGY), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i6.NxTriggerButton, 10));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NxPopoverTriggerDirective,
      selectors: [["", "nxPopoverTriggerFor", ""]],
      hostAttrs: ["aria-haspopup", "dialog"],
      hostVars: 2,
      hostBindings: function NxPopoverTriggerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function NxPopoverTriggerDirective_click_HostBindingHandler() {
            return ctx.handleClick();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-expanded", ctx.isOpen)("aria-describedby", ctx.isOpen ? ctx.id : null);
        }
      },
      inputs: {
        show: [0, "nxPopoverShow", "show"],
        closeable: [0, "nxPopoverCloseable", "closeable"],
        closeOnClickOutside: "closeOnClickOutside",
        hidePopoverArrow: "hidePopoverArrow",
        popoverWidth: [0, "nxPopoverWidth", "popoverWidth"],
        popoverMaxWidthh: [0, "nxPopoverMaxWidth", "popoverMaxWidthh"],
        popover: [0, "nxPopoverTriggerFor", "popover"],
        direction: [0, "nxPopoverDirection", "direction"],
        popoverInitialVisible: [0, "nxPopoverInitialVisible", "popoverInitialVisible"],
        visibleChange: [0, "nxPopoverVisibleChange", "visibleChange"],
        modal: [0, "nxPopoverModal", "modal"],
        trigger: [0, "nxPopoverTrigger", "trigger"],
        scrollStrategy: [0, "nxPopoverScrollStrategy", "scrollStrategy"]
      },
      outputs: {
        changeShow: "nxPopoverShowChange"
      },
      exportAs: ["nxPopoverTrigger"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPopoverTriggerDirective, [{
    type: Directive,
    args: [{
      selector: '[nxPopoverTriggerFor]',
      exportAs: 'nxPopoverTrigger',
      host: {
        '(click)': 'handleClick()',
        'aria-haspopup': 'dialog',
        '[attr.aria-expanded]': 'isOpen',
        '[attr.aria-describedby]': 'isOpen ? id : null'
      },
      standalone: true
    }]
  }], () => [{
    type: i1.Overlay
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i2$1.EventManager
  }, {
    type: i3.ConfigurableFocusTrapFactory
  }, {
    type: i3.FocusMonitor
  }, {
    type: i0.NgZone
  }, {
    type: i4.Platform
  }, {
    type: i5.Directionality,
    decorators: [{
      type: Optional
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [POPOVER_DEFAULT_OPTIONS]
    }]
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [NX_POPOVER_SCROLL_STRATEGY]
    }]
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i6.NxTriggerButton,
    decorators: [{
      type: Optional
    }, {
      type: Self
    }]
  }], {
    changeShow: [{
      type: Output,
      args: ['nxPopoverShowChange']
    }],
    show: [{
      type: Input,
      args: ['nxPopoverShow']
    }],
    closeable: [{
      type: Input,
      args: ['nxPopoverCloseable']
    }],
    closeOnClickOutside: [{
      type: Input
    }],
    hidePopoverArrow: [{
      type: Input
    }],
    popoverWidth: [{
      type: Input,
      args: ['nxPopoverWidth']
    }],
    popoverMaxWidthh: [{
      type: Input,
      args: ['nxPopoverMaxWidth']
    }],
    popover: [{
      type: Input,
      args: ['nxPopoverTriggerFor']
    }],
    direction: [{
      type: Input,
      args: ['nxPopoverDirection']
    }],
    popoverInitialVisible: [{
      type: Input,
      args: ['nxPopoverInitialVisible']
    }],
    visibleChange: [{
      type: Input,
      args: ['nxPopoverVisibleChange']
    }],
    modal: [{
      type: Input,
      args: ['nxPopoverModal']
    }],
    trigger: [{
      type: Input,
      args: ['nxPopoverTrigger']
    }],
    scrollStrategy: [{
      type: Input,
      args: ['nxPopoverScrollStrategy']
    }]
  });
})();
class NxPopoverModule {
  static {
    this.ɵfac = function NxPopoverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NxPopoverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NxPopoverModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, OverlayModule, NxIconModule, NxPopoverComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NxPopoverModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, OverlayModule, NxIconModule, NxPopoverTriggerDirective, NxPopoverComponent, NxPopoverContentDirective],
      exports: [NxPopoverTriggerDirective, NxPopoverComponent, NxPopoverContentDirective],
      providers: []
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NX_POPOVER_SCROLL_STRATEGY, NX_POPOVER_SCROLL_STRATEGY_PROVIDER, NX_POPOVER_SCROLL_STRATEGY_PROVIDER_FACTORY, NxPopoverComponent, NxPopoverContentDirective, NxPopoverIntl, NxPopoverModule, NxPopoverTriggerDirective, POPOVER_DEFAULT_OPTIONS, POPOVER_DEFAULT_OPTIONS_FACTORY, getNxPopoverInvalidDirectionError };
